export type PendingCrashReport = {
  message?: string
  componentStack?: string
}

// Transient hand-off between the Sentry error boundary fallback and the report
// screen it navigates to. Kept as a one-shot module value (not app state) so the
// crash context survives the navigation without being serialized into route
// params. Consumed exactly once so a later, crash-free visit to the report
// screen starts clean.
let pendingCrashReport: PendingCrashReport | null = null

export function setPendingCrashReport(report: PendingCrashReport | null): void {
  pendingCrashReport = report
}

export function consumePendingCrashReport(): PendingCrashReport | null {
  const report = pendingCrashReport
  pendingCrashReport = null
  return report
}
